import { Container, TestimonialCarousel } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import css from './UserQuotes.module.css'

export function UserQuotes() {
    const { t } = useTranslation(['slackalternative', 'common'])

    return (
        <Container className={css.userQuotesContainer}>
            <TestimonialCarousel
                nextButtonLabel={t('next', { ns: 'common' })}
                previousButtonLabel={t('previous', { ns: 'common' })}
                id="userTestimonials"
                testimonials={[
                    {
                        quotee: t('userQuotes.buffer.quotee'),
                        quoteeTitle: t('userQuotes.buffer.quoteeTitle'),
                        children: t('userQuotes.buffer.body'),
                        src: '',
                        alt: '',
                    },
                    {
                        quotee: t('userQuotes.remoteHow.quotee'),
                        quoteeTitle: t('userQuotes.remoteHow.quoteeTitle'),
                        children: t('userQuotes.remoteHow.body'),
                        alt: '',
                        src: '',
                    },
                    {
                        quotee: t('userQuotes.learningAlly.quotee'),
                        quoteeTitle: t('userQuotes.learningAlly.quoteeTitle'),
                        children: t('userQuotes.learningAlly.body'),
                        alt: '',
                        src: '',
                    },
                    {
                        quotee: t('userQuotes.wpmayor.quotee'),
                        quoteeTitle: t('userQuotes.wpmayor.quoteeTitle'),
                        children: t('userQuotes.wpmayor.body'),
                        alt: '',
                        src: '',
                    },
                ]}
            />
        </Container>
    )
}
